import { useTranslation } from "react-i18next";
import type { EducationDetailDto } from "../../types/client-education-detail.types";
import styles from "./sections.module.scss";

/**
 * Eğitimin serbest metin "İçerik" açıklaması. İnteraktif ünite/hedef oynatıcısı
 * ayrı bir bölümdür (ContentSection) ve `education-content` anchor'ını o taşır —
 * "İçeriğe Devam Et" oraya kaydırır. Bu bölüm bilgilendirme metnidir.
 */
export function EducationContentSection(props: { education: EducationDetailDto }) {
  const { t } = useTranslation();
  const text = props.education.content?.trim();

  if (!text) return null;

  return (
    <section id="education-content-text" className={styles.section}>
      <div className={styles.header}>
        <h2>{t("clientContentSection.title")}</h2>
      </div>
      <div className={styles.description}>{text}</div>
    </section>
  );
}
